enum TRANSLATION_NAMESPACES {
  TRANSLATION = 'translation',
}

export default TRANSLATION_NAMESPACES
